import { html } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
import './Text.css'; 

export const Text = ({ 
  content = '', 
  color = '', 
  fontSize = '16px', 
  textAlign = 'center', 
  fontWeight = 'normal', 
  fontStyle = 'normal', 
  backgroundColor = 'transparent', 
  borderColor = 'transparent', 
  borderWidth = '1px', 
  borderStyle = 'solid', 
  borderRadius = '4px',
  fontFamily = '',
  width = "",
  height = "auto",
  
}) => {
  return html`
    <div
      class="storybook-text"
      style=${styleMap({ 
        color, 
        fontSize, 
        textAlign, 
        fontWeight, 
        fontStyle, 
        backgroundColor,
        borderColor, 
        borderWidth, 
        borderStyle,
        borderRadius,
        fontFamily,
        width,
        height
        
      })}
    >
      ${content}
    </div>
  `;
};

